import smavaIllustration from 'assets/icons/voucher-money-smava.png'
import ffgIllustration100 from 'assets/icons/voucher-money-ffg-100.png'
import ffgIllustration150 from 'assets/icons/voucher-money-ffg-150.png'
import { VoucherBannerVariant } from '../../VoucherBanner.types'

const FFG_ILLUSTRATIONS: Record<number, string> = {
  100: ffgIllustration100,
  150: ffgIllustration150
}

export const VARIANT_COPY: Record<
  VoucherBannerVariant,
  {
    subtitle: string
    illustration: (amount: number | null) => string
    title: (amount: number | null) => string
  }
> = {
  smava: {
    subtitle: 'Nur bei smava.',
    illustration: () => smavaIllustration,
    title: (amount) => {
      return amount != null
        ? `${amount} € Gutschein erhalten!`
        : 'Gutschein erhalten!'
    }
  },
  ffg: {
    subtitle: 'Jetzt bei FINANZCHECK.',
    illustration: (amount) =>
      amount ? FFG_ILLUSTRATIONS[amount] : ffgIllustration100,
    title: (amount) => {
      return amount != null
        ? `${amount} € Gutschein erhalten!`
        : 'Gutschein erhalten!'
    }
  }
}
